<template>
  <div class="map-container">
    <div ref="googleMapContainer" class="map-view" :style="{'height': mapViewHeight}">
    </div>
    <div v-if="errorText" class="map-view-error-panel">
      {{errorText}}
    </div>
    <div v-if="loadingText" class="map-view-loading-panel">
      <Spinner small inline /> {{loadingText}}
    </div>
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot
        :google="google"
        :map="map"
        :mapState="mapState"
      />
    </template>
  </div>
</template>

<style>
.map-main-view {
  width: 100%;
  min-height: 65vh;
}
.map-container {
  position: relative;
}
.map-view-error-panel,
.map-view-loading-panel {
  position: absolute;
  left: 20px;
  bottom: 20px;
  border: 1px solid #a0a0a0;
  border-radius: 4px;
  background-color: #ffffff;
  padding: 8px;
}

.map-view-error-panel {
  color: #ff0000;
}
</style>

<script>
export default {
  name: 'MapView',
  computed: {
  },
  props: {
    autoDetectLocation: {
      type: Boolean,
      default: false
    },
    mapViewHeight: {
      type: String,
      default: '65vh'
    },
    streetViewControl: {
      type: Boolean,
      default: false
    },
    mapTypeControl: {
      type: Boolean,
      default: false
    },
    defaultZoom: {
      type: Number,
      default: 16
    },
    errorText: String,
    loadingText: String
  },
  data() {
    return {
      google: null,
      map: null,
      mapState: {
        zoom: 0
      }
    }
  },
  mounted() {
    this.$mapService.loadGoogleMaps().then(() => {
      this.$nextTick(() => {
        this.initializeMap()
      })
    })
  },
  beforeDestroy() {
    if(this.map && this.google) {
      this.google.maps.event.clearInstanceListeners(this.map)
    }
  },
  methods: {
    initializeMap() {
      const mapContainer = this.$refs.googleMapContainer
      if(!mapContainer)
        return

      this.google = this.$mapService.googleMapAPI

      var mapConfig = {
        zoom: this.defaultZoom,
        mapTypeControl: this.mapTypeControl,
        streetViewControl: this.streetViewControl,
        gestureHandling: 'greedy',
        mapId: process.env.VUE_APP_GOOGLE_MAP_ID
      }
      this.map = new this.google.maps.Map(mapContainer, mapConfig)

      let self = this
      this.map.addListener('center_changed', () => {
        self.onMapBoundsChanged()
      })
      this.map.addListener('bounds_changed', () => {
        self.onMapBoundsChanged()
      })
      this.google.maps.event.addListenerOnce(this.map, 'tilesloaded', function() {
        // Trigger bounds on startup
        self.$nextTick(() => {
          self.onMapBoundsChanged()
          self.onMapDataLoaded()
        })
      })

      if(this.autoDetectLocation && navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          this.map.setCenter(pos);
        },
        () => { })
      }

      this.$nextTick(() => {
        this.$emit('mapLoaded')
      })
      
    },

    // Pan to fit/zoom to show a list of points
    // pointList - Array of objects containing lng/lat coordinates
    panToFitPointList(pointList) {
      if(!pointList || pointList.length == 0 || this.map == null)
        return

      var bounds = new this.google.maps.LatLngBounds()

      pointList.forEach(position => {
        bounds.extend(position)
      })

      this.map.fitBounds(bounds)
      this.map.panToBounds(bounds)
    },

    onMapBoundsChanged() {
      if(this.map && this.map.getBounds()) {
        let bounds = this.map.getBounds().toJSON()
        this.$emit('updateBounds', { min: { lng: bounds.west, lat: bounds.north }, max: { lng: bounds.east, lat: bounds.south }})

        this.$set(this.mapState, 'zoom', this.map.getZoom())
      }
    },

    onMapDataLoaded() {
      this.$emit('mapReady')
    }
  }
}
</script>
